<template>
    <modal
        id="employee-list-modal"
        size="large"
        v-model="showModal"
        :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Employee')"
        @submit="submit"
        :loading="loading"
        :btn-label="selectedUrl ? $t('save') : $t('invite')"
        :preloader="preloader">

        <form
            v-if="isMailSettingExist || selectedUrl"
            ref="form"
            :data-url='selectedUrl ? selectedUrl : EMPLOYEE_INVITE'
            @submit.prevent="submitData"
        >
          <div class="row">
            <div class="col-md-6">
              <app-form-group
                  :label="$t('email')"
                  :placeholder="$placeholder('email')"
                  v-model="formData.email"
                  :required="true"
                  :error-message="$errorMessage(errors, 'email')"
              />
            </div>
            <div class="col-md-6">
              <app-form-group
                  :label="$t('phone_number')"
                  :placeholder="$placeholder('phone_number')"
                  v-model="formData.phone"
                  :required="true"
                  :error-message="$errorMessage(errors, 'phone')"
              />
            </div>
          </div>
            <app-form-group
                :label="$t('gender')"
                type="radio"
                :list="[
                {id:'male',value: $t('male')},
                {id:'female', value:  $t('female')},
                // {id:'other', value:  $t('other')}
            ]"
                v-model="formData.gender"
                :error-message="$errorMessage(errors, 'gender')"
            />
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('employee_id')"
                        :placeholder="$placeholder('employee_id')"
                        v-model="formData.employee_id"
                        :required="true"
                        :error-message="$errorMessage(errors, 'employee_id',true,true)"
                    />

                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('department')"
                        list-value-field="name"
                        v-model="formData.department_id"
                        :chooseLabel="$t('department')"
                        :error-message="$errorMessage(errors, 'department_id')"
                        :fetch-url="SELECTABLE_DEPARTMENT"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('designation')"
                        list-value-field="name"
                        v-model="formData.designation_id"
                        :chooseLabel="$t('designation')"
                        :error-message="$errorMessage(errors, 'designation_id')"
                        :fetch-url="SELECTABLE_DESIGNATION"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('employment_status')"
                        list-value-field="name"
                        v-model="formData.employment_status_id"
                        :chooseLabel="$t('employment_status')"
                        :error-message="$errorMessage(errors, 'employment_status_id')"
                        :fetch-url="`${SELECTABLE_EMPLOYMENT_STATUS}?excluded=terminated`"
                    />
                </div>
            </div>

          <div class="my-3">
            <h6 v-if="checkDisable" class="text-danger">{{ $fieldTitle('weekend_days', '') }}</h6>
            <h6 v-else class="text-danger">{{ $fieldTitle('select_your_weekend_days', '') }}</h6>
          </div>
          <div class="mb-primary">
            <app-input
                type="checkbox"
                :list="weekdays"
                v-model="formData.weekdays"
                radio-checkbox-wrapper="row"
                custom-checkbox-type="checkbox-default col-md-3"
                :error-message="$errorMessage(errors, 'weekdays')"
            />
          </div>

            <app-form-group-selectable
                type="multi-select"
                v-if="$can('attach_users_to_roles')"
                :label="$t('role')"
                list-value-field="name"
                v-model="formData.roles"
                :chooseLabel="$t('role')"
                :error-message="$errorMessage(errors, 'roles')"
                :fetch-url="SELECTABLE_ROLE"
            />
            <app-form-group
                v-if="!selectedUrl"
                type="number"
                :label="$t('salary')"
                :placeholder="$placeholder('salary')"
                v-model="formData.salary"
                :required="true"
                :error-message="$errorMessage(errors, 'salary')"
            />
          <div class="row">
            <div class="col-md-6">
              <app-form-group
                  type="date"
                  :label="$t('joining_date')"
                  :placeholder="$placeholder('joining_date')"
                  v-model="formData.joining_date"
                  :required="true"
                  :error-message="$errorMessage(errors, 'joining_date')"
              />
            </div>
            <div class="col-md-6">
              <app-form-group
                  type="select"
                  :label="$t('nationality')"
                  :chooseLabel="$t('country')"
                  v-model="formData.country"
                  :list="countries"
                  form-group-class="mb-md-0"
                  :error-message="$errorMessage(errors, 'country')"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-form-group
                  type="date"
                  :label="$t('contract_start_date')"
                  :placeholder="$placeholder('contract_start_date')"
                  v-model="formData.contract_start_date"
                  :required="true"
                  :error-message="$errorMessage(errors, 'contract_start_date')"
              />
            </div>
            <div class="col-md-6">
              <app-form-group
                  type="date"
                  :label="$t('contract_end_date')"
                  :placeholder="$placeholder('contract_end_date')"
                  v-model="formData.contract_end_date"
                  :required="true"
                  :error-message="$errorMessage(errors, 'contract_end_date')"
              />
            </div>
          </div>
<!--          <div class="row">-->
<!--            <div class="col-md-12">-->
<!--              <app-form-group-->
<!--                  type="select"-->
<!--                  :label="$t('line_manager')"-->
<!--                  :chooseLabel="$t('line_manager')"-->
<!--                  v-model="formData.line_manager"-->
<!--                  :list="[]"-->
<!--                  form-group-class="mb-md-0"-->
<!--                  :error-message="$errorMessage(errors, 'line_manager')"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->
              <app-form-group-selectable
                  type="select"
                  :label="$t('line_manager')"
                  list-value-field="full_name"
                  v-model="formData.line_manager"
                  :chooseLabel="$t('line_manager')"
                  :error-message="$errorMessage(errors, 'line_manager')"
                  :fetch-url="apiUrl.LINE_MANAGERS"
              />

            <app-form-group
                v-if="from === 'user'"
                class="mb-primary"
                type="single-checkbox"
                label=""
                :list-value-field="$t('do_not_show_in_employee_list')"
                v-model="formData.dont_show_in_employee"
            />
        </form>
        <app-note v-else
                  :title="$t('no_delivery_settings_found')"
                  :notes="$optional(currentTenant, 'is_single') ?
                  `<ol>
                     <li>${$t('cron_job_settings_warning',{
                      documentation: `<a href='https://payday.gainhq.com/documentation/important-settings.html#scheduler-queue' target='_blank'>${$t('documentation')}</a>`
                  })}</li>
                     <li>${$t('no_delivery_settings_warning', {
                      location: `<a href='${urlGenerator(TENANT_EMAIL_SETUP_SETTING)}'>${$t('here')}</a>`
                  })}</li>
                  </ol>`: [$t('no_delivery_settings_warning_none')]"
                  content-type="html"
        />
        <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
            <button type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal">
                {{ $t('close') }}
            </button>
        </template>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
    EMPLOYEES_LIST,
    SELECTABLE_DEPARTMENT,
    SELECTABLE_ROLE,
    SELECTABLE_DESIGNATION,
    SELECTABLE_EMPLOYMENT_STATUS,
    EMPLOYEE_INVITE, AUTO_EMPLOYEE_ID,
} from "../../../Config/ApiUrl";
import {
    TENANT_MAIL_CHECK_URL,
    TENANT_EMAIL_SETUP_SETTING
} from "../../../../common/Config/apiUrl";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {formatDateForServer} from "../../../../common/Helper/Support/DateTimeHelper";
import {addChooseInSelectArray} from "../../../../common/Helper/Support/FormHelper";
import countries from "./Helper/countries";

export default {
    name: "EmployeeListCreateEditModel",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        from: {
            type: String,
            default: 'employee',
            line_manager: 'Line Manager'
        }
    },
    data() {
        return {
            weekdays: [
              {id: "sun", value: this.$t("sunday")},
              {id: "mon", value: this.$t("monday")},
              {id: "tue", value: this.$t("tuesday")},
              {id: "wed", value: this.$t("wednesday")},
              {id: "thu", value: this.$t("thursday")},
              {id: "fri", value: this.$t("friday")},
              {id: "sat", value: this.$t("saturday")},
            ],
            isMailSettingExist: true,
            formData: {
                employee_id: '',
                weekdays: [],
                department: {},
                roles: [],
                designation: {},
                employment_status: {},
                is_in_employee: false,
                nationality: '',
                contract_end_date: '',
                contract_start_date: '',
                line_manager: '',
            },
            EMPLOYEES_LIST,
            SELECTABLE_DEPARTMENT,
            SELECTABLE_ROLE,
            SELECTABLE_DESIGNATION,
            SELECTABLE_EMPLOYMENT_STATUS,
            EMPLOYEE_INVITE,
            TENANT_EMAIL_SETUP_SETTING
        }
    },
    methods: {
        submit() {
            this.fieldStatus.isSubmit = true;
            this.loading = true;
            this.message = '';
            this.errors = {};
            this.formData.is_in_employee = this.formData.dont_show_in_employee ? 0 : 1;
            this.formData.joining_date = formatDateForServer(this.formData.joining_date);
            this.formData.contract_start_date = formatDateForServer(this.formData.contract_start_date);
            this.formData.contract_end_date = formatDateForServer(this.formData.contract_end_date);
            this.submitData(this.formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#employee-list-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, this.from === 'employee' ? 'employee-table' : 'user-table');
            if (this.from === 'user') {
                this.$hub.$emit(`reload-role-table`)
            }
        },
        afterSuccessFromGetEditData({data}) {
            this.preloader = false;
            this.formData = data;
            this.formData.employee_id = data.profile?.employee_id;
            this.formData.roles = this.collection(data.roles).pluck();
            this.formData.designation_id = data.designation?.id;
            this.formData.department_id = data.department?.id;
            this.formData.employment_status_id = data.employment_status?.id;
            this.formData.dont_show_in_employee = parseInt(this.formData.is_in_employee) ? 0 : 1;
            this.formData.joining_date = data.profile?.joining_date ? new Date(data.profile?.joining_date) : null;
            this.formData.contract_start_date = data.contract_start_date ? new Date(data.contract_start_date) : null;
            this.formData.contract_end_date = data.contract_end_date ? new Date(data.contract_end_date) : null;
            this.formData.gender = data.profile?.gender;
            // this.formData
        },
        checkMailSettings() {
            this.preloader = true;
            axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
                this.isMailSettingExist = !!response.data;
            }).finally(() => {
                this.preloader = false;
            });
        },
        generateModalTitle(subject) {
            return this.$fieldTitle(this.selectedUrl ? 'edit' : 'invite', subject, true);
        },
        checkEmployeeID() {
            axiosGet(AUTO_EMPLOYEE_ID).then(response => {
                this.formData.employee_id = response.data;
            }).finally(() => {
                this.preloader = false;
            });
        }
    },
    computed: {
      countries() {
        return addChooseInSelectArray(countries, 'value', this.$t('country'))
      },
      checkDisable () {
        return this.selectedUrl ? (this.formData.attendances_count > 0 || !this.$can('update_working_shifts') || this.viewOnly ):
            !this.$can('create_working_shifts')
      }
    },
    created() {
        this.checkMailSettings();
        if (!this.selectedUrl) {
            this.checkEmployeeID();
        }
    }
}
</script>

